// ErrorContext.js
import React, { createContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import axios from 'axios';

const ErrorContext = createContext();

export const ErrorContextProvider = ({ children }) => {
  const [hasError, setHasError] = useState(false);
//   const { user } = useAuth();
  const history = useHistory();
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  console.log("hittt")

  const sendErrorToServer = async (error, info = '') => {
    let response
    try {
      response = await axios.post('https://fprqyudop4.execute-api.ap-south-1.amazonaws.com/test/verify_batch_transaction', {
        error: error?.toString(),
        info,
        route: window.location.pathname,
        // user_id: user?.Username || 'anonymous',
        // user_email: user?.email || '',
        // phone_number: user?.phone_number || '',
        // user_group: user?.user_group || '',
        // user_name: `${user?.['custom:first_name'] ?? ''} ${user?.['custom:last_name'] ?? ''}`,
        // institution_id: `${user?.['custom:institution_id'] ?? ''}`,
        // institution_name: `${user?.['custom:institution_name'] ?? ''}`,
        // organization_id: `${user?.['custom:organization_id'] ?? ''}`,
        // organization_name: `${user?.['custom:organization_name'] ?? ''}`,
        timestamp: new Date().toISOString(),
      });
      console.log("response" , response)
    } catch (e) {
      console.log('Failed to report error:', e);
    }
  };

//   useEffect(() => {
//     const handleGlobalError = (event) => {
//       sendErrorToServer(event.error || event.message, 'Global JS error');
//       setTimeout(() => {
//         if (isMounted.current) {
//           setHasError(true);
//           // Optional redirect:
//           // history.push('/error');
//         }
//       }, 0);
//     };

//     const handleUnhandledRejection = (event) => {
//       sendErrorToServer(event.reason, 'Unhandled Promise rejection');
//       setTimeout(() => {
//         if (isMounted.current) {
//           setHasError(true);
//           // Optional redirect:
//           // history.push('/error');
//         }
//       }, 0);
//     };

//     window.addEventListener('error', handleGlobalError);
//     window.addEventListener('unhandledrejection', handleUnhandledRejection);

//     return () => {
//       window.removeEventListener('error', handleGlobalError);
//       window.removeEventListener('unhandledrejection', handleUnhandledRejection);
//     };
//   }, []);

  if (hasError) {
    return (
      <div style={{ textAlign: 'center', padding: 50 }}>
        <h2>😢 Something went wrong.</h2>
        <p>Please refresh the page or contact support.</p>
        <button onClick={() => window.location.reload()}>Reload</button>
      </div>
    );
  }

  return (
    <ErrorContext.Provider value={{ hasError }}>
      {children}
    </ErrorContext.Provider>
  );
};

export default ErrorContext;
